import React from 'react';
import Icon from '@/components/ui/AppIcon';

const steps = [
  {
    step: '01',
    icon: 'PencilSquareIcon',
    title: 'Submit Your Product',
    desc: 'List your product with details, review guidelines, and the number of creators you want. Takes under 10 minutes.',
    color: '#FF5722',
    bg: '#FFF3EE',
  },
  {
    step: '02',
    icon: 'CreditCardIcon',
    title: 'Pay & Go Live',
    desc: 'Pay via Razorpay. Receive your GST invoice instantly. Your product listing goes live to our creator network.',
    color: '#1A237E',
    bg: '#EEF0FB',
  },
  {
    step: '03',
    icon: 'UsersIcon',
    title: 'Creators Pick Your Product',
    desc: 'Verified creators and reviewers matching your target profile browse and pick products they\'re interested in reviewing.',
    color: '#8B5CF6',
    bg: '#F5F3FF',
  },
  {
    step: '04',
    icon: 'SparklesIcon',
    title: 'AI-Verified Reviews Come In',
    desc: 'AI scores each review for quality and honesty. Approved reviews go live on Amazon/Flipkart.',
    color: '#10B981',
    bg: '#ECFDF5',
  },
];

export default function HowCampaignsWork() {
  return (
    <section className="section-py bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <span className="pill-badge mb-3">Process</span>
          <h2 className="font-heading font-bold text-foreground mt-3" style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)' }}>
            How Product Reviews Work
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((step, i) => (
            <div key={step.step} className="bg-white rounded-2xl border border-border p-6 space-y-4 card-hover shadow-sm">
              <div className="flex items-center justify-between">
                <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ backgroundColor: step.bg }}>
                  <Icon name={step.icon as 'PencilSquareIcon'} size={22} style={{ color: step.color }} />
                </div>
                <span className="font-heading font-bold text-3xl" style={{ color: `${step.color}20` }}>{step.step}</span>
              </div>
              <h3 className="font-heading font-semibold text-foreground text-sm">{step.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}